import { FC } from 'react';

type NumberedCalloutProps = {
  number: number;
  text: string;
};

/**
 * Numbered verdict callout. The lead sentence renders bold; the rest is
 * regular weight.
 */
const NumberedCallout: FC<NumberedCalloutProps> = ({ number, text }) => {
  const firstStop = text.indexOf('. ');
  const lead = firstStop === -1 ? text : text.slice(0, firstStop + 1);
  const rest = firstStop === -1 ? '' : text.slice(firstStop + 1);

  return (
    <div className="flex items-start gap-3 rounded-xl border border-neutral-200 bg-white px-5 py-4">
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 font-heading text-xs font-bold text-white">
        {number}
      </span>
      <p className="font-body text-sm text-neutral-700">
        <span className="font-bold text-neutral-800">{lead}</span>
        {rest}
      </p>
    </div>
  );
};

export default NumberedCallout;
